import m from "../../geodata/es2015/seychellesHigh";
window.am4geodata_seychellesHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/seychellesHigh.js
// module id = null
// module chunks = 